import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlowNozzle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 25,
	viewBox: "0 0 50.0 25.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 A 50.0 10.0 0.0 0 0 50.0 7.0 L 50.0 18.0 A 50.0 10.0 0.0 0 0 0.0 25.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFlowNozzle;
